import { getImageProps } from 'next/image';

// The 26px mask is drawn at 122%, so a 32px image with the loader's 2x
// source keeps the existing artwork sharp without downloading the full PNG.
const { props: bridgeMask } = getImageProps({
  src: '/assets/navigation/unit-bridge.png',
  width: 32,
  height: 32,
  alt: '',
});

export default function UnitBridgeIcon() {
  return (
    <span
      aria-hidden="true"
      className="inline-block size-[26px] shrink-0 bg-current"
      style={{
        maskImage: `url("${bridgeMask.src}")`,
        maskRepeat: 'no-repeat',
        // Frame the supplied artwork without its transparent outer margins.
        maskSize: '122%',
        maskPosition: '50% 63%',
      }}
    />
  );
}
